import {ChangeDetectionStrategy, Component} from '@angular/core'

@Component({
  selector: 'cft-hero-cover-plot, h2[cft-hero-cover-plot], h2[cft-hero-cover-plot]',
  templateUrl: './hero-cover-plot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference '../../../../styles/theme.css';

    :host {
      @apply block;
      @apply text-white;
      @apply text-base font-medium;
      @apply drop-shadow-3;
      @apply max-w-(--container-lg);
    }
  `,
})
export class HeroCoverPlotComponent {}
